<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputPreview'
export default {
  name: 'DIdentityPreview',
  extends: compoment
}
</script>
